import type { ChartAxisX } from '@/admin/dashboards/chartViewModel';

/** X tick label for attempt-number score progression. */
export function formatScoreAttemptAxis(x: ChartAxisX): string {
  return String(x);
}

/** X tick label for weekly helpfulness bars. */
export function formatChartWeekAxis(x: ChartAxisX): string {
  const raw = String(x);
  const d = new Date(raw.slice(0, 10));
  if (Number.isNaN(d.getTime())) return raw;
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

/** X tick label for session-week score progression (ordinal week 1, 2, 3 — not calendar dates). */
export function formatScoreSessionWeekAxis(x: ChartAxisX): string {
  return formatScoreAttemptAxis(x);
}
